import { PageHeader, Card, MediaImage, EmptyState } from '../ui';
import { useBinder } from '../../lib/useBinder';
import { mediaUrl } from '../../api/client';
import { ShowButton } from '../common/ShowButton';
import shared from './sections.module.css';
import styles from './GallerySection.module.css';

function filenameTitle(path: string): string {
  const file = path.split('/').filter(Boolean).at(-1) ?? path;
  return file.replace(/\.[^.]+$/, '').replace(/[-_]+/g, ' ');
}

/** Aggregate gallery of all adventure images that can be shown to players. */
export function GallerySection() {
  const ctx = useBinder();
  if (!ctx) return null;
  const { adventure, instance, state, slug } = ctx;
  void state;

  const images = new Map<string, string>();
  const addImage = (path: string | undefined, title: string) => {
    if (!path || images.has(path)) return;
    images.set(path, title || filenameTitle(path));
  };

  addImage(adventure.cover, 'Copertina');
  for (const character of adventure.characters) addImage(character.image, character.name);
  for (const [title, path] of Object.entries(adventure.images)) addImage(path, title);

  const gallery = Array.from(images.entries()).map(([path, title]) => ({ path, title }));

  return (
    <div>
      <PageHeader eyebrow="Galleria" title="Galleria immagini" />
      <p className={shared.lead}>
        Raccoglie le immagini dell'avventura e permette di mostrarle rapidamente ai giocatori.
      </p>

      {!gallery.length ? (
        <EmptyState icon="🖼️" title="Nessuna immagine" />
      ) : (
        <div className={shared.gridWide}>
          {gallery.map((image) => (
            <Card key={image.path} padded={false} className={styles.tile}>
              <MediaImage
                src={mediaUrl(slug, image.path)}
                alt={image.title}
                fallback="🖼️"
                fit="contain"
                className={styles.image}
              />
              <div className={styles.caption}>
                <span className={styles.title}>{image.title}</span>
                <ShowButton
                  slug={slug}
                  image={image.path}
                  title={image.title}
                  instanceId={instance.id}
                />
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
